import { MenuItem, Popover, capitalize } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { memo, useState } from "react";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import clsx from "clsx";
import { palette } from "../../theme/palette";

const useStyles = makeStyles({
  icon: {
    width: "20px",
    height: "19px",
    margin: 0,
    color: palette.typography.white.high,
    transform: "rotate(90deg)",
  },
  item: {
    minWidth: "180px",
  },
  selected: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
  },
});

export const StartAdornment = memo(({ value, onChange, options }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const styles = useStyles();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };

  return (
    <>
      <ChevronRightIcon className={styles.icon} onClick={handleOpen} />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 30,
          horizontal: -10,
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={index}
            className={clsx(styles.item, option === value && styles.selected)}
            value={option}
            onClick={() => {
              onChange(option);
              setAnchorEl(null);
            }}
          >
            {capitalize(option)}
          </MenuItem>
        ))}
      </Popover>
    </>
  );
});
